import React from 'react';
import {Pressable, PressableProps, View} from 'react-native';
import {Icon, makeStyles} from '@rneui/themed';

import Text from '../../themed/Text';

type props = {
  onPress: PressableProps['onPress'];
  mode: 'print' | 'screen';
}


export function ViewMyCardCTA({onPress, mode = 'screen' }: props) {
  const styles = useStyles();
  return (
    <Pressable onPress={onPress}>
      <View
        style={[
          styles.container,
          {
            // backgroundColor: '#FFDD04',
            flexDirection: 'row',
            borderRadius: 4,
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingHorizontal: 20,
            height: 54,
          },
          styles.shadowStyle,
        ]}>
        <Text
          style={[
            styles.text,
            {
              // color: '#0054A6',
              fontSize: 18,
              fontWeight: 'bold',
            },
          ]}>
          {mode === 'print' ? 'PRINT CARD' : 'VIEW MY CARD'}
        </Text>
        <Icon
          name="barcode-scan"
          type="material-community"
          size={30}
          color={styles.text.color}
        />
      </View>
    </Pressable>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.colors?.legacy?.background?.hero?.header,
  },
  text: {
    color: theme.colors?.legacy?.text?.hero?.header,
  },
  shadowStyle: {
    shadowColor: '#171717',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.2,
    shadowRadius: 3,
  },
}));
